import styled from 'styled-components';

export const MetaData = styled.p`
    font-size: 12px;
    margin: 0;
`;
